import {
  GetEstablishmentByUrnQuery,
  GetEstablishmentByUrnQueryVariables,
} from '@app/generated/graphql'
import { gql, useQuery } from 'urql'

export const GET_DFE_BY_URN = gql`
  query GetEstablishmentByUrn($urn: String!) {
    dfe_establishment(where: { urn: { _eq: $urn } }, limit: 1) {
      id
      urn
      name
      organizations(limit: 1) {
        id
        name
      }
    }
  }
`

export const useDfeByUrn = (urn?: string | null) => {
  const [{ data, error, fetching }] = useQuery<
    GetEstablishmentByUrnQuery,
    GetEstablishmentByUrnQueryVariables
  >({
    query: GET_DFE_BY_URN,
    variables: { urn: urn ?? '' },
    pause: !urn,
  })
  return { data, error, fetching }
}
